<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fas fa-toolbox"></i
      >{{
        isShowPaymentMethods
          ? "Select Payment Methods"
          : "Select Payment Options"
      }}
    </h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="justify-content-center" *ngIf="!showThirdPartySelection">
      <div class="form-row mb-4" *ngIf="isShowPaymentMethods && canPayPartial">
        <a href="javascript:void(0)" class="back" (click)="back()"
          ><i class="fas fa-arrow-left"></i> Back</a
        >
      </div>
      <div class="form-row mb-4" *ngIf="!isShowPaymentMethods">
        <button
          type="button"
          class="offset-2 btn btn-outline col-8"
          (click)="showPaymentMethods(false)"
        >
          Pay Full
        </button>
      </div>
      <div class="form-row mb-4" *ngIf="!isShowPaymentMethods">
        <button
          type="button"
          class="offset-2 btn btn-outline col-8"
          (click)="showPaymentMethods(true)"
        >
          Pay Partial
        </button>
      </div>
      <div
        class="form-row mb-4"
        *ngIf="isShowPaymentMethods && showCreditCardOption"
      >
        <button
          type="button"
          class="offset-2 btn btn-outline col-8"
          (click)="selectPaymentOption('PayCard')"
        >
          Pay via Card
        </button>
      </div>
      <div
        class="form-row mb-4"
        *ngIf="isShowPaymentMethods && showACHPaymentOption"
      >
        <button
          type="button"
          class="offset-2 btn btn-outline col-8"
          (click)="selectPaymentOption('PayACH')"
        >
          Pay via ACH
        </button>
      </div>
      <div
        class="form-row mb-4"
        *ngIf="isShowPaymentMethods && !hideManualPaymentOption"
      >
        <button
          type="button"
          class="offset-2 btn btn-outline col-8"
          (click)="selectPaymentOption('PayManual')"
        >
          Manual Payment
        </button>
      </div>
      <div
        class="form-row mb-4"
        *ngIf="isShowPaymentMethods && showCashPayment"
      >
        <button
          type="button"
          class="offset-2 btn btn-outline col-8"
          (click)="selectPaymentOption('PayCash')"
        >
          Cash Payment
        </button>
      </div>

      <div
        class="form-row mb-4"
        *ngIf="isShowPaymentMethods && showGooglePayOption"
      >
        <button
          type="button"
          class="offset-2 btn btn-outline col-8"
          (click)="selectPaymentOption('ThirdParty')"
        >
          Pay via Google Pay
        </button>
      </div>
    </div>
    <!-- Third Party Payment -->
    <div class="justify-content-center" *ngIf="showThirdPartySelection">
      <div class="form-row mb-4">
        <div class="offset-2 col-8">
          <div class="custom-control custom-switch">
            <input
              id="invoiceAgreeTermsThirdParty"
              type="checkbox"
              class="custom-control-input"
              [(ngModel)]="agreedToTerms"
              [ngClass]="{ 'is-invalid': !agreedToTerms }"
              required
              name="agreedToTerms"
            />
            <label
              class="custom-control-label"
              for="invoiceAgreeTermsThirdParty"
            >
              I have read and agree to the
              <a
                id="invoiceOpenTermsAndConditionThirdParty"
                class="redify form-label-custom"
                href="javascript:void(0)"
                (click)="openTermsAndCondition()"
                >Terms and Conditions</a
              >. Information will be used as described here and in the
              <a
                id="invoiceOpenPolicyThirdParty"
                class="redify form-label-custom"
                href="javascript:void(0)"
                (click)="openPolicy()"
                >Privacy Policy</a
              >.
            </label>
          </div>
        </div>
      </div>
      <div
        class="form-row mb-4 mt-10"
        *ngIf="showGooglePayOption && locationData?.MID"
      >
        <div class="offset-2 col-8">
          <app-google-pay-button
            (tokenize)="processGooglePayResponse($event)"
            [gatewayMerchantId]="locationData?.MID"
            [googlePayMerchantId]="locationData?.GooglePayMerchantId"
            [amount]="amount"
            [canTokenize]="agreedToTerms"
          ></app-google-pay-button>
        </div>
      </div>
      <div
        class="form-row mb-4"
        *ngIf="isShowPaymentMethods && showCreditCardOption"
      >
        <button
          type="button"
          class="offset-2 btn btn-outline col-8"
          (click)="selectPaymentOption('PayCard')"
        >
          Pay via Card
        </button>
      </div>
      <div
        class="form-row mb-4"
        *ngIf="isShowPaymentMethods && showACHPaymentOption"
      >
        <button
          type="button"
          class="offset-2 btn btn-outline col-8"
          (click)="selectPaymentOption('PayACH')"
        >
          Pay via ACH
        </button>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="close()">
      Close
    </button>
  </div>
</div>

<ng-template #container>
  <div
    class="modal-content modal-content-right"
    id="invoicePaymentSelectionModal"
  >
    <div class="modal-header">
      <h1 class="modal-title pull-left">{{ tcpTitle }}</h1>
      <button
        id="invoicePaymentSelectionCloseModal"
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="closeCurrentDialog()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div [innerHTML]="tcpContent" class="tcp-content text-secondary"></div>
    </div>
  </div>
</ng-template>
